module.exports = ".text-style{\r\n  font-weight:bold;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/category-components/parent-category/parent-category-list/parent-category-list.component.css
// module id = ./src/app/category-components/parent-category/parent-category-list/parent-category-list.component.css
// module chunks = main